import { createAsyncThunk } from "@reduxjs/toolkit";
import authApi from "../../authApi";
import { showSnackbar } from "../../Slice/snackbar/snackbarSlice";
import {
  setAdvanceSearchProjectScoopData,
  setFreelanceInvoiceWithSettings,
  setInvoiceSetting,
  setInvoiceWithSettings,
  setJobReport,
  setJobsFromTmsSummeryViewSearch,
  setProjectStatistics,
  setProjectStatisticsLinguist,
  setScoopReportStats,
  setScoopStatusDetails,
  setSingleClientInvoiceLinguist,
} from "../../Slice/ReportModule/ReportSlice";
import { setLoading } from "../../Slice/loading/loadingSlice";
import { setInvoiceReport } from "../../Slice/ReportModule/ReportSlice";
import { setLinguistReport } from "../../Slice/ReportModule/ReportSlice";
import { setMarginReport } from "../../Slice/ReportModule/ReportSlice";
import { setSingleClientInvoice } from "../../Slice/ReportModule/ReportSlice";
import { setScoopReport } from "../../Slice/ReportModule/ReportSlice";

export const FilterScoopReport = createAsyncThunk(
  "scoopReportCustomFilter/create",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/scoopReportCustomFilter`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setScoopReport(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getScoopReportStats = createAsyncThunk(
  "getScoopReportStats/",
  async (request, { dispatch, rejectWithValue }) => {
    try {
      const response = await authApi.post(`/getScoopReportStats`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setScoopReportStats(response?.data));
        return response?.data;
      }
      return rejectWithValue(response); // ❌ Ensure failure goes to .rejected

    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const FilterJobsReport = createAsyncThunk(
  "jobReportCustomFilter/create",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/jobReportCustomFilter`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setJobReport(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getJobsFromTmsSummeryViewSearch = createAsyncThunk(
  "getJobsFromTmsSummeryViewSearch",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/getJobsFromTmsSummeryViewSearch`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setJobsFromTmsSummeryViewSearch(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const FilterInvoiceReport = createAsyncThunk(
  "statusInvoiceReportFilterCustom/create",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/statusInvoiceReportFilterCustom`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setInvoiceReport(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const FilterLinguistReport = createAsyncThunk(
  "linguistInvoiceFilterCustom/create",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/linguistInvoiceFilterCustom`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setLinguistReport(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const MarginReportList = createAsyncThunk(
  "jobReportMargin",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/jobReportMargin`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setMarginReport(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const JobsMarkApprovedNegative = createAsyncThunk(
  "jobReportMargin",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/jobsMarkApprovedNegative`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.msg || "Successfully Updated",
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const SingleInvoiceView = createAsyncThunk(
  "clientInvoiceViewOne",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/clientInvoiceViewOne/${request}`);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setSingleClientInvoice(response?.data));
        return response?.data;
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const SingleInvoiceViewLinguist = createAsyncThunk(
  "invoiceViewOne",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/invoiceViewOne/${request}`);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setSingleClientInvoiceLinguist(response?.data));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setSingleClientInvoiceLinguist([]));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Something went wrong",
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const updateInvoiceCommentNote = createAsyncThunk(
  "updateInvoiceCommentNote",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.put(
        `/updateInvoiceCommentNote/${request.invoice_id}`,
        request
      );
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Successfully Inserted",
            type: "success",
          })
        );
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const ClientInvoiceSetting = createAsyncThunk(
  "clientInvoiceSetting",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/clientInvoiceSetting`);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setInvoiceSetting(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const invoiceWithSettings = createAsyncThunk(
  "invoiceWithSettings",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/invoiceWithSettings`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setInvoiceWithSettings(response?.data));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const freelanceInvoiceCreate = createAsyncThunk(
  "freelanceInvoiceCreate/create",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/freelanceInvoiceCreate`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setFreelanceInvoiceWithSettings(response?.data));
        // dispatch(
        //   showSnackbar({
        //     message: response?.data?.msg || "Successfully Inserted",
        //     type: "success",
        //   })
        // );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
// ----------------- finance statistics -------------

export const projectStatistics = createAsyncThunk(
  "projectStatistics",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/projectStatistics`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setProjectStatistics(response?.data));
        // dispatch(
        //   showSnackbar({
        //     message: response?.data?.msg || "Successfully fetched.",
        //     type: "success",
        //   })
        // );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const projectStatisticsLinguist = createAsyncThunk(
  "projectStatisticsLinguist",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/projectStatisticsLinguist`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setProjectStatisticsLinguist(response?.data));
        // dispatch(
        //   showSnackbar({
        //     message: response?.data?.msg || "Successfully Inserted",
        //     type: "success",
        //   })
        // );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const scoopProjectsOrderFilter = createAsyncThunk(
  "dashboardProjectsOrderGetSearch",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/dashboardProjectsOrderGetSearch`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setScoopStatusDetails(response?.data));
        //   dispatch(
        //     showSnackbar({
        //       message: response?.data?.msg || "Successfully Inserted",
        //       type: "success",
        //     })
        //   );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const advanceSearchProjectScoopData = createAsyncThunk(
  "advanceSearchProjectScoopData",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/advanceSearchProjectScoopData`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setAdvanceSearchProjectScoopData(response?.data));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("Error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
